import type {
  AdminCorrespondenceEmailHistoryRequest,
  AdminEmailTemplateListRequest,
  AdminEmailTemplateListResponse,
  AdminEmailTemplatePreviewRequest,
  AdminEmailTemplatePreviewResponse,
  AdminEmailTemplateSaveRequest,
  AdminEmailTemplateSaveResponse,
  EmailCode,
  EmailId,
  EmailStatus,
  PageResultDto,
} from '@/venit/services/model/techpubs-cms';
import axios, { AxiosResponse } from 'axios';

export interface EmailDataDto {
  id: EmailId;
  emailCode: EmailCode;
  lang: string;
  status: EmailStatus;
  sender: string;
  recipients: string[];
  ccRecipients: string[];
  bccRecipients: string[];
  htmlBody: string;
  subject: string;
  originalEmailId: EmailId | null;
  createdOn: string;
  updatedOn: string;
}

export interface CorrespondenceEmailHistoryResponse {
  emailList: PageResultDto<EmailDataDto>;
}

export default class CorrespondenceManagementService {
  public list(request: AdminCorrespondenceEmailHistoryRequest): Promise<AxiosResponse<CorrespondenceEmailHistoryResponse>> {
    return axios.post<CorrespondenceEmailHistoryResponse>('/api/admin/correspondence/email-history-list', request);
  }

  public listEmailTemplates(request: AdminEmailTemplateListRequest): Promise<AxiosResponse<AdminEmailTemplateListResponse>> {
    return axios.post<AdminEmailTemplateListResponse>('/api/admin/correspondence/email-template-list', request);
  }

  public saveEmailTemplate(request: AdminEmailTemplateSaveRequest): Promise<AxiosResponse<AdminEmailTemplateSaveResponse>> {
    return axios.post<AdminEmailTemplateSaveResponse>('/api/admin/correspondence/email-template-save', request);
  }

  public previewEmailTemplate(request: AdminEmailTemplatePreviewRequest): Promise<AxiosResponse<AdminEmailTemplatePreviewResponse>> {
    return axios.post<AdminEmailTemplatePreviewResponse>('/api/admin/correspondence/email-template-preview', request);
  }
}
